import { h, JSX, FunctionalComponent } from 'preact';
import { useState } from 'preact/hooks';
import { generateId } from '../../utils/generate-id';
import { TooltipTailLeftIcon } from '@uw/icons';
import './tooltip.scss';

export interface TooltipProps {
  title: string;
  icon: JSX.Element;
  ariaLabel?: string;
}

export const Tooltip: FunctionalComponent<TooltipProps> = (props) => {
  const { title, ariaLabel, icon, children } = props;

  const [id] = useState(generateId());
  const [isOpened, setIsOpened] = useState(false);

  return (
    <div className="uwaw-main-tooltip-container">
      <div
        id={`uwaw-tooltip-icon-${id}`}
        tabIndex={0}
        role="button"
        aria-expanded={isOpened}
        aria-describedby={`uwaw-tooltip-${id}`}
        aria-label={ariaLabel}
        className="uwaw-main-tooltip-icon"
        onFocus={() => setIsOpened(true)}
        onMouseOver={() => setIsOpened(true)}
        onBlur={() => setIsOpened(false)}
        onMouseOut={() => setIsOpened(false)}
      >
        {icon}
      </div>
      <div id={`uwaw-tooltip-${id}`} role="tooltip" className="uwaw-main-tooltip">
          {/* @ts-expect-error preact SVG typing does not fully support all attributes */}
          <TooltipTailLeftIcon svgAttrs={{ 'aria-hidden': 'true' }} className="uwaw-main-tooltip__tail" />
          <div className="uwaw-main-tooltip__i">
            <p className="uwaw-main-tooltip__title">{title}</p>
            {children}
          </div>
        </div>
    </div>
  );
};
